import HomePage from './pages/HomePage';
import SOFPage from './pages/SOFPage';
import TeamPage from './pages/TeamPage';
import FellowshipsPage from './pages/FellowshipsPage';
import SBIPage from './pages/SBIPage';
//this is causing problems in the schedule
import NavBar from './components/shared/NavBar';
import Footer from './components/shared/Footer';
import ScrollToTop from './components/shared/ScrollToTop';
import {Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <NavBar/>
        <Routes>
          <Route path='/' element={<HomePage/>}/>
          <Route path='/statement-of-faith' element={<SOFPage/>}/>
          <Route path='/team' element={<TeamPage/>}/>
          <Route path='/fellowships' element={<FellowshipsPage/>}/>
          <Route path='/sbi' element={<SBIPage/>}/>
        </Routes>
      <Footer/>
      <ScrollToTop />
    </LanguageProvider>
  );
}

export default App;